export enum UserGroupEnum {
    BUYER = 1,
    EXPERT_CLASSIC = 2,
    ADMIN_SUPERUSER = 3,
    ADMIN_OPERATOR = 5,
    AFFILIATE = 6,
    ADMIN_GOVEX = 7,
    ADMIN_EXT = 8,
    PARTNER = 10,
    PARTNER_EXPERT = 11,
    PARTNER_EXPERT_TEASING = 12,
    PROSPECT = 13,
    MKT_EXT = 15,
    VALIDATOR_EXT = 16,
    TEAM_MEMBER = 17,
}